export const DiffView = ({ diff, testId = "diff-view" }) => {
  if (!diff) return null;
  return (
    <div data-testid={testId} className="wrap-anywhere box-border flex w-full min-w-0 max-w-full flex-wrap gap-1 overflow-x-hidden rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 font-mono text-xs leading-7 sm:p-3 sm:text-sm">
      {diff.ops.length === 0 && <span className="text-slate-400">No response</span>}
      {diff.ops.map((o, i) => (
        <span key={i} className={"max-w-full " + (
          o.t === "eq" ? "rounded bg-emerald-100 px-1 text-emerald-800"
            : o.t === "miss" ? "rounded bg-rose-100 px-1 text-rose-800 line-through"
              : "rounded bg-amber-100 px-1 text-amber-800 italic")
        } title={o.t === "eq" ? "correct" : o.t === "miss" ? "missed" : "extra"}>{o.w}</span>
      ))}
    </div>
  );
};

export const DiffLegend = () => (
  <div className="flex flex-wrap gap-3 text-xs text-slate-500">
    <span><span className="mr-1 inline-block h-2 w-2 rounded-full bg-emerald-400" />Matched</span>
    <span><span className="mr-1 inline-block h-2 w-2 rounded-full bg-rose-400" />Missed</span>
    <span><span className="mr-1 inline-block h-2 w-2 rounded-full bg-amber-400" />Extra / wrong</span>
  </div>
);
